/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import {Button, Container, MDBBreadcrumb, MDBBreadcrumbItem, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'

import http from '../../Component/Interceptor/Interseptor'
import {Link, Redirect} from 'react-router-dom'
import cookie from 'react-cookies'
import WAREHOUSE from '../BaseComponent/WAREHOUSE'

class AddDocType extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      docs: [],
      object: {},
      array: [],
      error: '',
      wareType: [],
      typePrimary: '',
      redirect: false
    }
  }

  componentDidMount() {}

  submitForm(e) {
    e.preventDefault()
  }

  addDocType() {
    let name = document.getElementById('name').value
    var typePrimary = document.getElementById('typePrimary').value

    let nameError = false
    let typePrimaryError = false
    let addError = false
    let rowData = this.state.docs

    if (name == '') {
      nameError = true
      addError = true
      message.error('لطفا نام سند را وارد کنید')
      this.setState({
        error: 'لطفا نام سند را وارد کنید'
      })
    } else {
      if (!nameError) {
        this.setState({
          error: ''
        })
      }
    }

    if (typePrimary == '') {
      typePrimaryError = true
      addError = true
      message.error('لطفا نوع وارده یا صادره بودن را وارد کنید')
      this.setState({
        error: 'لطفا نوع وارده یا صادره بودن را وارد کنید'
      })
    } else {
      if (!typePrimaryError) {
        this.setState({
          error: ''
        })
      }
    }

    if (!addError) {
      if (typePrimary == 'all') {
        var data = {
          name: name,
          isIn: true,
          isOut: true
        }
      } else {
        let isInStatus = typePrimary == 'true'
        var data = {
          name: name,
          isIn: isInStatus,
          isOut: !isInStatus
        }
      }

      // alert(JSON.stringify(data))

      http
        .post(`${WAREHOUSE.WAREHOUSE_TYPE_ADD_DOCUMENT}`, data, {})
        .then((response) => {
          if (response.data.error == null) {
            this.setState({
              redirect: true
            })
            message.success('نوع سند با موفقیت اضافه شد')
          } else {
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  renderRedirect = () => {
    if (this.state.redirect) {
      return <Redirect to="/listDocType" />
    }
  }

  submit(e) {
    e.preventDefault()
  }

  render() {
    const style = this.state.docs.length == '0' ? '' + ' hide' : 'warehouseTable'

    return (
      <div className="rtl">
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>
              <Link to={'/listDocType'}>لیست نوع سند ها</Link>
            </li>
            <li>ثبت نوع سند</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>ثبت نوع سند</p>
            </div>
            <div className="formComponent">
              <label htmlFor="name">
                نام نوع سند : <span className="requireFiled">*</span>
              </label>
              <input type="text" className="form-control" id="name" name="name" />

              <label htmlFor="name">
                نوع سند : <span className="requireFiled">*</span>
              </label>
              <select className="form-control" id="typePrimary" name="typePrimary">
                <option value="">---------</option>
                <option value={true}>نوع وارده</option>
                <option value={false}>نوع صادره</option>
                <option value="all">نوع وارده و صادره</option>
              </select>
              <button type="button" className="form-control btn btn-info" onClick={this.addDocType.bind(this)}>
                ثبت نهایی
              </button>
              {this.renderRedirect()}
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default AddDocType
